import React from 'react';
import { styled } from '@miro-site/ui-styled-engine';
import { Section, Grid, GridItem, Typography, Button, ArrowToRight } from '@miro-site/ui-core';
import FeatureIcon from './FeatureIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FeatureGridItem = styled(GridItem, {
  '.feature': {
    '&-description': {
      marginTop: 'stacking-300',
      marginBottom: '$600'
    }
  },
  '.new-label': {
    backgroundColor: '$background-warning-idle',
    borderRadius: '$100',
    padding: '$150',
    display: 'inline',
    marginLeft: '$150'
  }
});

var FeatureSection = function FeatureSection(props) {
  var _props$features, _props$cta, _props$cta2;

  return /*#__PURE__*/_jsxs(Section, {
    pageTopInset: "1200",
    children: [/*#__PURE__*/_jsx(Grid, {
      children: /*#__PURE__*/_jsx(GridItem, {
        columnStart: "1",
        columnEnd: {
          '@initial': -1,
          '@sm': 7,
          '@xxl': 6
        },
        children: /*#__PURE__*/_jsx(Typography, {
          offsetBottom: {
            '@initial': '600',
            '@lg': '800'
          },
          variant: "heading-2",
          tag: "h3",
          type: "heading",
          renderChildrenAsHTML: true,
          children: (props === null || props === void 0 ? void 0 : props.title) || ''
        })
      })
    }), /*#__PURE__*/_jsx(Grid, {
      css: {
        gridRowGap: '0'
      },
      children: props === null || props === void 0 ? void 0 : (_props$features = props.features) === null || _props$features === void 0 ? void 0 : _props$features.map(function (feature, index) {
        return /*#__PURE__*/_jsxs(FeatureGridItem, {
          xs: 12,
          sm: 6,
          children: [/*#__PURE__*/_jsx(FeatureIcon, {}), /*#__PURE__*/_jsx(Typography, {
            variant: "heading-4",
            className: "feature-title",
            offsetBottom: "stacking-200",
            offsetTop: "100",
            renderChildrenAsHTML: true,
            children: (feature === null || feature === void 0 ? void 0 : feature.title) || ''
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "body-text-1",
            offsetBottom: {
              '@initial': '400',
              '@lg': '600'
            },
            className: "feature-description",
            renderChildrenAsHTML: true,
            children: (feature === null || feature === void 0 ? void 0 : feature.content) || ''
          })]
        }, 'feature-' + index);
      })
    }), /*#__PURE__*/_jsx(Grid, {
      children: /*#__PURE__*/_jsx(GridItem, {
        xs: 12,
        children: /*#__PURE__*/_jsx(Button, {
          appearance: "filled",
          endIcon: /*#__PURE__*/_jsx(ArrowToRight, {}),
          rounded: true,
          size: "large",
          variant: "primary",
          href: props === null || props === void 0 ? void 0 : (_props$cta = props.cta) === null || _props$cta === void 0 ? void 0 : _props$cta.href,
          children: props === null || props === void 0 ? void 0 : (_props$cta2 = props.cta) === null || _props$cta2 === void 0 ? void 0 : _props$cta2.text
        })
      })
    })]
  });
};

export default FeatureSection;